import { readFromStorage, writeToStorage } from './storage.js';
export * from './v1.js';
export const paymentConfigServiceDefinition = {
    id: `payment-config-service`,
    optionalDependencies: {
        featureServices: {
            's2:logger': `^1.0.0`,
        },
    },
    create: ({ featureServices }) => {
        const { 's2:logger': logger = console } = featureServices;
        const configChangeListeners = new Set();
        let loadCalculatorListener;
        let openCalculatorListener;
        let { config, leasingParams, params } = readFromStorage(logger);
        const pendingOpenCalculatorListenerParamsQueue = [];
        return {
            '1.0.0': (consumerId) => {
                return {
                    featureService: {
                        getConfig: () => config,
                        subscribe: (listener, options) => {
                            const l = [
                                listener,
                                options?.matchers ?? [`submit`],
                            ];
                            configChangeListeners.add(l);
                            return createUnsubscribe(() => configChangeListeners.delete(l), options);
                        },
                        registerCalculatorLoader: (listener, options) => {
                            loadCalculatorListener = listener;
                            void Promise.resolve().then(() => {
                                if (loadCalculatorListener === listener &&
                                    pendingOpenCalculatorListenerParamsQueue.length > 0) {
                                    loadCalculatorListener();
                                }
                            });
                            return createUnsubscribe(() => {
                                if (loadCalculatorListener === listener) {
                                    loadCalculatorListener = undefined;
                                }
                            }, options);
                        },
                        registerCalculator: (listener, options) => {
                            openCalculatorListener = listener;
                            void Promise.resolve().then(() => {
                                do {
                                    if (openCalculatorListener === listener) {
                                        const _params = pendingOpenCalculatorListenerParamsQueue.shift();
                                        if (_params) {
                                            openCalculatorListener(..._params);
                                        }
                                    }
                                    else {
                                        break;
                                    }
                                } while (pendingOpenCalculatorListenerParamsQueue.length > 0);
                            });
                            return createUnsubscribe(() => {
                                if (openCalculatorListener === listener) {
                                    openCalculatorListener = undefined;
                                }
                            }, options);
                        },
                        openCalculator: ({ purchaseItem, initialConfig = config }) => {
                            const onConfigChangeCb = async (newConfig, event) => {
                                config = newConfig;
                                if (config.mode === `finance`) {
                                    params = config.params;
                                }
                                else if (config.mode === `leasing`) {
                                    leasingParams = config.leasingParams;
                                    params = config.params;
                                }
                                for (const [onConfigChange, matchers,] of configChangeListeners) {
                                    if (!matchers.includes(event)) {
                                        continue;
                                    }
                                    const configChange = onConfigChange({
                                        consumerId,
                                        purchaseItem,
                                    });
                                    if (configChange instanceof Promise) {
                                        await configChange;
                                    }
                                }
                                if (event === `submit`) {
                                    writeToStorage({ config, leasingParams, params }, logger);
                                }
                            };
                            const calcParams = [
                                {
                                    purchaseItem,
                                    calculatorConfig: initialConfig && {
                                        leasingParams,
                                        params,
                                        ...initialConfig,
                                    },
                                },
                                (p) => onConfigChangeCb(p, `submit`),
                                onConfigChangeCb,
                            ];
                            if (openCalculatorListener) {
                                openCalculatorListener(...calcParams);
                            }
                            else {
                                pendingOpenCalculatorListenerParamsQueue.push(calcParams);
                                loadCalculatorListener?.();
                            }
                        },
                    },
                };
            },
        };
    },
};
function createUnsubscribe(onUnsubscribe, options = {}) {
    options.signal?.addEventListener(`abort`, onUnsubscribe);
    return onUnsubscribe;
}
//# sourceMappingURL=index.js.map